import { FC } from 'react';

import { useSetRecoilState } from 'recoil';

import { LinkIcon } from 'assets/icons';
import threeShapeImage from 'assets/images/3shape.png';
import Button from 'components/Button/Button';
import { Divider } from 'components/Divider/Divider';
import { FEATURE_WALKTHROUGH } from 'constants/common';
import { useTreatmentContext } from 'contexts/treatment.context';
import { useUpdateUserPreference } from 'services/hooks/TemplateSettings.hooks';
import { featureWalkthrough } from 'store/atoms/authAtom';
import { translate } from 'utils';
import useThreeShapeHooks from 'utils/customHooks/threeShape.hooks';

interface ThreeShapeUploadSectionProps {
  disabled?: boolean;
}

const ThreeShapeUploadSection: FC<ThreeShapeUploadSectionProps> = ({
  disabled = false
}) => {
  const { clinicId, patientDetails } = useTreatmentContext();

  const [updateUserPreference] = useUpdateUserPreference();
  const setFeatureWalkthrough = useSetRecoilState(featureWalkthrough);
  const { authLoading, handleThreeShapeAuth } = useThreeShapeHooks({
    clinicId,
    treatmentId: patientDetails?.id
  });
  const handleHideButtonClick = () => {
    updateUserPreference({
      variables: {
        name: FEATURE_WALKTHROUGH,
        preference: { hasShownThreeShapeIntro: true }
      },
      onCompleted: () => {
        setFeatureWalkthrough((prev: any) => ({
          ...prev,
          hasShownThreeShapeIntro: true
        }));
      }
    });
  };
  return (
    <>
      <Divider direction='vertical' className='h-3/5 mx-16' />
      <div className='flex flex-col items-center justify-center'>
        <img src={threeShapeImage} alt='three shape' className='mb-1 w-22' />
        <h2 className='text-17px text-DEFAULT_TEXT mb-2 block text-center'>
          <span className=''>{translate('three.shape.import')}</span>
        </h2>
        <button
          className='text-xs text-DISABLED_2 mb-6 underline'
          onClick={handleHideButtonClick}
          disabled={authLoading || disabled}
          type='button'
        >
          {translate('common.hide')}
        </button>
        <Button
          onClick={handleThreeShapeAuth}
          className='md:flex bg-DEFAULT_TEXT text-white text-center h-12 pl-4 pr-6 py-3 disabled:bg-DISABLED_2 disabled:text-white'
          type='button'
          disabled={disabled || authLoading}
        >
          <>
            <LinkIcon />
            <span className='pt-0.5 ml-3 text-sm leading-6'>
              {translate('three.shape.connect')}
            </span>
          </>
        </Button>
      </div>
    </>
  );
};

export default ThreeShapeUploadSection;
